import React, { useState, useEffect, useMemo } from "react";
import { StatsInvoice } from "../common/home/Stats";
import donasi from "../../assets/images/icon_donation/donation.svg";
import { useDispatch } from "react-redux";
import { setLoading } from "../../core/feature/config/configSlice";
import {
  getDonationById,
  getDonations,
  paymentDonation,
} from "../../core/service/api_donation";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import User from "../../core/models/user";
import { useAppSelector } from "../../core/feature/hooks";
import { formatCurrency } from "../../config/global";
import { toast } from "react-toastify";
import { getBalance } from "../../core/service/api_balance";
import { removeBalance, setBalance } from "../../core/feature/user/balanceSlice";
import filter from "../../../assets/images/icon_invoice/filter.svg";
import CurrencyInput from "react-currency-input-field";
import { useTranslation } from "react-i18next";
import { Transition } from "@headlessui/react";
import { BackButton } from "../common/BackButton";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import CustomApp from "../../core/models/customApp";
import { isDarkColor } from "../../config/DarkColorChecker";

const ComponentDonationDetail = () => {
  const gaEventTracker = useAnalyticsEventTracker("Transaction");
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  const user: User = useAppSelector((state) => state.user.user);
  const balance: Number = useAppSelector((state) => state.balance.balance);
  const getBalanceMemo = useMemo(() => formatCurrency(balance), [balance]);
  const [data, setData] = useState<any>({});
  const [historyDonation, setHistoryDonation] = useState<any>([]);
  let location: any = useLocation();
  const dispatch = useDispatch();
  const [amount, setAmount] = useState("");
  const [isActive, setIsActive] = useState(true);
  const navigate = useNavigate();
  const [isi, setIsi] = useState("");
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const { t } = useTranslation();
  const [showHistory, setShowHistory] = useState(false);

  const addDonation = async () => {
    if (isNaN(parseInt(amount))) {
      return toast.warning(t("DONATION-DETAIL.isNotEmpty"));
    }
    if (balance < parseInt(amount))
      return toast.warning(t("INVOICE.balanceEmpty") + formatCurrency(balance));

    var query = {
      accountId: user.accounts[0].id,
      callerId: "",
      amount: parseInt(amount),
      cash: true,
      channel: "WEB",
      donationId: data.id,
    };
    console.log(query);
    
    dispatch(setLoading(true));
    paymentDonation(query)
      .then((res: any) => {
        dispatch(setLoading(false));
        gaEventTracker("Click Donation", "Payment Donation Success");

        toast.success(t("DONATION-DETAIL.success"));
        setAmount(isi);
        getDonationHistory();
        getBalance()
          .then((res) => {
            dispatch(setBalance(res.data.balance));
            navigate(-1);
          })
          .catch((err) => {
            dispatch(setLoading(false));
          });
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
      });
  };

  const getDonationHistory = async () => {
    dispatch(setLoading(true));
    getDonationById(data.id)
      .then((res: any) => {
        console.log(res.data, "data");
        if(res.data.participants){
          setHistoryDonation(res.data.participants.reverse());
        }
        setTotal(res.data.participants.length);
        console.log(res);
        dispatch(setLoading(false));
      })
      .catch((err: any) => {
        console.log(err);
        dispatch(setLoading(false));
      });
  };

  useEffect(() => {
    setData(JSON.parse(location.state.data));
  }, []);
  useEffect(() => {
    if (data.id) {
      getDonationHistory();
    }
  }, [data]);

  const changePage = (newPage: any) => {
    dispatch(setLoading(true));
    setPage(newPage);
    getDonationById(data.id)
      .then((res: any) => {
        console.log(res.data, "data");
        setHistoryDonation(res.data.participants);
        setTotal(res.data.participants.length);
        console.log(res);
        dispatch(setLoading(false));
      })
      .catch((err: any) => {
        console.log(err);
        dispatch(setLoading(false));
      });
  };

  const changeSize = (newSize: any) => {
    dispatch(setLoading(true));
    setSize(newSize);
    getDonationById(data.id)
      .then((res: any) => {
        console.log(res.data, "data");
        setHistoryDonation(res.data.participants);
        setTotal(res.data.participants.length);
        console.log(res);
        dispatch(setLoading(false));
      })
      .catch((err: any) => {
        console.log(err);
        dispatch(setLoading(false));
      });
  };

  const openHistory = () => {
    setShowHistory(true);
  };

  return (
    <div className="font-montserrat bg-psp-primary pb-20">
      <StatsInvoice />
      <div className="container relative w-full -mt-44 bg-white shadow rounded-2xl pb-10">
        <div className="container h-full w-full pt-3">
          <div className="flex">
            <BackButton />
            <div className="font-bold text-4xl">
              {t("DONATION-DETAIL.title")}
            </div>
          </div>
          <div className="container-fluid w-full mt-4 py-3">
            <div className="container-fluid rounded-xl bg-white shadow-xl w-full grid grid-flow-col">
              <div className="pt-[33px] pl-6">
                <span>{t("DONATION-DETAIL.balance")}</span>
                <p className="text-4xl font-bold text-blue-700">
                  {getBalanceMemo}
                </p>
              </div>
              <div className="flex justify-end py-3">
                <image>
                  <svg
                    width="185"
                    height="105"
                    viewBox="0 0 185 105"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <ellipse
                      cx="179.839"
                      cy="4.00323"
                      rx="4.18228"
                      ry="4.00323"
                      fill="#7E00AA"
                    />
                    <ellipse
                      cx="179.839"
                      cy="28.0228"
                      rx="4.18228"
                      ry="4.00323"
                      fill="#7E00AA"
                    />
                    <ellipse
                      cx="179.839"
                      cy="52.0423"
                      rx="4.18228"
                      ry="4.00323"
                      fill="#7E00AA"
                    />
                    <ellipse
                      cx="154.745"
                      cy="4.00323"
                      rx="4.18228"
                      ry="4.00323"
                      fill="#0054E6"
                    />
                    <ellipse
                      cx="154.745"
                      cy="28.0228"
                      rx="4.18228"
                      ry="4.00323"
                      fill="#0054E6"
                    />
                    <ellipse
                      cx="154.745"
                      cy="52.0423"
                      rx="4.18228"
                      ry="4.00323"
                      fill="#0054E6"
                    />
                    <ellipse
                      cx="154.745"
                      cy="76.0599"
                      rx="4.18228"
                      ry="4.00323"
                      fill="#0054E6"
                    />
                    <ellipse
                      cx="129.651"
                      cy="4.00323"
                      rx="4.18228"
                      ry="4.00323"
                      fill="#0054E6"
                    />
                    <ellipse
                      cx="129.651"
                      cy="28.0228"
                      rx="4.18228"
                      ry="4.00323"
                      fill="#0054E6"
                    />
                    <ellipse
                      cx="129.651"
                      cy="52.0423"
                      rx="4.18228"
                      ry="4.00323"
                      fill="#0054E6"
                    />
                    <ellipse
                      cx="129.651"
                      cy="76.0599"
                      rx="4.18228"
                      ry="4.00323"
                      fill="#0054E6"
                    />
                    <ellipse
                      cx="129.651"
                      cy="100.083"
                      rx="4.18228"
                      ry="4.00323"
                      fill="#0054E6"
                    />
                    <ellipse
                      cx="104.557"
                      cy="4.00323"
                      rx="4.18228"
                      ry="4.00323"
                      fill="#0054E6"
                      fill-opacity="0.5"
                    />
                    <ellipse
                      cx="104.557"
                      cy="28.0228"
                      rx="4.18228"
                      ry="4.00323"
                      fill="#0054E6"
                      fill-opacity="0.5"
                    />
                    <ellipse
                      cx="104.557"
                      cy="52.0423"
                      rx="4.18228"
                      ry="4.00323"
                      fill="#0054E6"
                      fill-opacity="0.5"
                    />
                    <ellipse
                      cx="104.557"
                      cy="76.0599"
                      rx="4.18228"
                      ry="4.00323"
                      fill="#0054E6"
                      fill-opacity="0.5"
                    />
                    <ellipse
                      cx="104.557"
                      cy="100.083"
                      rx="4.18228"
                      ry="4.00323"
                      fill="#0054E6"
                      fill-opacity="0.5"
                    />
                    <ellipse
                      cx="79.4635"
                      cy="28.0228"
                      rx="4.18228"
                      ry="4.00323"
                      fill="#0054E6"
                      fill-opacity="0.5"
                    />
                    <ellipse
                      cx="79.4635"
                      cy="52.0423"
                      rx="4.18228"
                      ry="4.00323"
                      fill="#0054E6"
                      fill-opacity="0.5"
                    />
                    <ellipse
                      cx="79.4635"
                      cy="76.0599"
                      rx="4.18228"
                      ry="4.00323"
                      fill="#0054E6"
                      fill-opacity="0.5"
                    />
                    <ellipse
                      cx="79.4635"
                      cy="100.083"
                      rx="4.18228"
                      ry="4.00323"
                      fill="#0054E6"
                      fill-opacity="0.5"
                    />
                    <ellipse
                      cx="54.3698"
                      cy="52.0423"
                      rx="4.18228"
                      ry="4.00323"
                      fill="#0054E6"
                      fill-opacity="0.2"
                    />
                    <ellipse
                      cx="54.3698"
                      cy="76.0599"
                      rx="4.18228"
                      ry="4.00323"
                      fill="#0054E6"
                      fill-opacity="0.2"
                    />
                    <ellipse
                      cx="54.3698"
                      cy="100.083"
                      rx="4.18228"
                      ry="4.00323"
                      fill="#0054E6"
                      fill-opacity="0.2"
                    />
                    <ellipse
                      cx="29.276"
                      cy="76.0599"
                      rx="4.18228"
                      ry="4.00323"
                      fill="#0054E6"
                      fill-opacity="0.2"
                    />
                    <ellipse
                      cx="29.276"
                      cy="100.083"
                      rx="4.18228"
                      ry="4.00323"
                      fill="#0054E6"
                      fill-opacity="0.2"
                    />
                    <ellipse
                      cx="4.18228"
                      cy="100.083"
                      rx="4.18228"
                      ry="4.00323"
                      fill="#0054E6"
                      fill-opacity="0.2"
                    />
                  </svg>
                </image>
              </div>
            </div>

            <div className="mt-4 w-full">
              <p>{t("DONATION-DETAIL.input")}</p>
              <div className="flex flex-row">
                <CurrencyInput
                  className="px-3 w-full rounded-lg h-10 border-1 border-psp-border-gray border-solid active:border-0"
                  placeholder="Rp 0"
                  decimalsLimit={2}
                  prefix={"Rp "}
                  onValueChange={(value, name) => {
                    setAmount(value || "");
                    value == undefined ? setIsActive(true) : setIsActive(false);
                    console.log(value);
                  }}
                />
                <button
                  onClick={() => addDonation()}
                  style={{ backgroundColor: customApp?.app_accent_color }}
                  className={`px-5 py-2 rounded-xl ml-20 shadow-md hover:bg-amber-500 ${isDarkColor(customApp.app_accent_color)?'text-white':'text-black'}`}
                >
                  {t("DONATION-DETAIL.button")}
                </button>
              </div>
            </div>

            <div className="mt-4">
              <div className="grid grid-flow-col">
                <div>
                  <h3>{t("DONATION-DETAIL.history")}</h3>
                </div>
                <div className="flex justify-end">
                  <button onClick={() => setShowHistory(!showHistory)}>
                    <image>
                      <svg
                        width="35"
                        height="35"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect width="24" height="24" rx="3" fill="white" />
                        <path
                          opacity="0.4"
                          d="M11.0416 13.9785H7.75388C7.33778 13.9785 7 14.3104 7 14.7192C7 15.1274 7.33778 15.4598 7.75388 15.4598H11.0416C11.4578 15.4598 11.7955 15.1274 11.7955 14.7192C11.7955 14.3104 11.4578 13.9785 11.0416 13.9785Z"
                          fill="black"
                        />
                        <path
                          opacity="0.4"
                          d="M17.0001 9.18934C17.0001 8.78107 16.6623 8.44922 16.2467 8.44922H12.959C12.5429 8.44922 12.2051 8.78107 12.2051 9.18934C12.2051 9.59815 12.5429 9.93 12.959 9.93H16.2467C16.6623 9.93 17.0001 9.59815 17.0001 9.18934Z"
                          fill="black"
                        />
                        <path
                          d="M10.4389 9.18928C10.4389 10.1226 9.66943 10.8791 8.71943 10.8791C7.77 10.8791 7 10.1226 7 9.18928C7 8.25649 7.77 7.5 8.71943 7.5C9.66943 7.5 10.4389 8.25649 10.4389 9.18928Z"
                          fill="black"
                        />
                        <path
                          d="M17.0004 14.6996C17.0004 15.6324 16.231 16.3889 15.281 16.3889C14.3315 16.3889 13.5615 15.6324 13.5615 14.6996C13.5615 13.7663 14.3315 13.0098 15.281 13.0098C16.231 13.0098 17.0004 13.7663 17.0004 14.6996Z"
                          fill="black"
                        />
                      </svg>
                    </image>
                  </button>
                </div>
              </div>
              <div>
                <Transition
                  show={showHistory}
                  enter="transition-opacity duration-200"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="transition-opacity duration-150"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <div className="mt-4">
                    {historyDonation.map((res: any, index: any) => {
                      return (
                        <div>
                          <div
                            key={index}
                            className="w-full rounded-xl shadow-md mb-4"
                          >
                            <div className="grid grid-flow-col">
                              <div className="py-2 pl-2 mr-4 justify-start flex">
                                <img src={donasi} alt="" className="w-16" />
                                <div className="mt-2 ml-4">
                                  <span className="text-xl">{data.title}</span>
                                  <p className="text-slate-400">
                                    {moment(res.dateTime).format(
                                      "DD MMMM YYYY"
                                    )}
                                  </p>
                                </div>
                              </div>
                              <div className="flex justify-end text-2xl pt-7 mr-4">
                                <span>{formatCurrency(res.amount)}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </Transition>
              </div>
              {/* <div className="flex relative mt-10 justify-between">
                <div className="pt-2 w-1/4">
                  <p>
                    {t("TRANSACTION.showing")} {page + 1} {t("TRANSACTION.to")}{" "}
                    {size} of {total} {t("TRANSACTION.entry")}
                  </p>
                </div>
                <div className="w-auto">
                  <div className="">
                    <select
                      onChange={(value) => {
                        changeSize(value.target.value);
                      }}
                      value={size}
                      className="py-2 border rounded-lg bg-white"
                    >
                      <option value={5}>5</option>
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                      <option value={1000}>1000</option>
                    </select>
                    <span className="ml-1">{t("TRANSACTION.page")}</span>
                  </div>
                </div>
                <div className="flex w-1/4">
                  <button
                    onClick={() => changePage(page - 1)}
                    disabled={page === 0}
                    className="disabled:bg-slate-200 disabled:text-slate-400 border mr-2 bg-blue-300 text-blue-600 rounded-md w-36 hover:text-white hover:bg-psp-hover"
                  >
                    {t("TRANSACTION.prev")}
                  </button>
                  <button
                    onClick={() => changePage(page + 1)}
                    disabled={(page + 1) * size > total}
                    className="disabled:bg-slate-200 disabled:text-slate-400 border mr-2 bg-blue-300 text-blue-600 rounded-md w-36 hover:text-white hover:bg-psp-hover"
                  >
                    {t("TRANSACTION.next")}
                  </button>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComponentDonationDetail;
